
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 17.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm8 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM5.5 3.5a1 1 0 01.956.705l.028.116.395 2.179h13.456a1 1 0 01.989 1.151l-.766 5a1 1 0 01-.988.849H8.152l.183 1H18.5a1 1 0 01.117 1.993l-.117.007h-11a1 1 0 01-.956-.705l-.028-.116L4.666 5.5H3.5a1 1 0 01-.117-1.993L3.5 3.5h2z"}})])
          )
        }
      }
    